<template>
  <div>
    <div class="border-b pd-y-5">
      <p
        @click="$router.push('/').catch(() => {})"
        class="text-font-14 mg-y-4"
      >
        <i class="fas fa-home"></i>
        หน้าหลัก
      </p>
       <p
        v-if="user.role == 50"
        @click="$router.push('/manage/course/instructor').catch(() => {})"
        class="text-font-14 mg-y-4"
      >
        <i class="fas fa-calendar-alt"></i>
        จัดการหลักสูตร
      </p>
      <p
        v-if="user.role == 80 || user.role == 60"
        @click="$router.push('/manage/course/list').catch(() => {})"
        class="text-font-14 mg-y-4"
      >
        <i class="fas fa-calendar-alt"></i>
        จัดการหลักสูตร
      </p>
      <p
        v-if="user.role == 80"
        @click="$router.push('/admin/list').catch(() => {})"
        class="text-font-14 mg-y-4"
      >
        <i class="fas fa-user-friends"></i>
        จัดการรายชื่อผู้ดูแลระบบ
      </p>
      <p
        v-if="user.role == 80 || user.role == 60"
        @click="$router.push('/instructor/list').catch(() => {})"
        class="text-font-14 mg-y-4"
      >
        <i class="fas fa-user-friends"></i>
        จัดการรายชื่อผู้สอน
      </p>
      <p
        v-if="user.role == 80 || user.role == 60"
        @click="$router.push('/name/list').catch(() => {})"
        class="text-font-14 mg-y-4"
      >
        <i class="fas fa-users"></i>
        จัดการรายชื่อผู้เรียน
      </p>
      <p
        v-if="user.role == 80 || user.role == 60 || user.role == 50"
        @click="$router.push('/manage/activity/score').catch(() => {})"
        class="text-font-14 mg-y-4"
      >
        <i class="far fa-file"></i>
        จัดการคะแนนหลักสูตร
      </p>
      <p
        v-if="user.role == 80 || user.role == 60 || user.role == 50"
        @click="$router.push('/summary/name/list').catch(() => {})"
        class="text-font-14 mg-y-4"
      >
        <i class="far fa-copy"></i>
        สรุปรายชื่อผู้เรียนหลักสูตร
      </p>
      <p
        v-if="user.role == 80 || user.role == 60"
        @click="$router.push('/feedback/name/list').catch(() => {})"
        class="text-font-14 mg-y-4"
      >
        <i class="far fa-calendar-check"></i>
        ผลการประเมินหลักสูตร
      </p>
      <p
        v-if="user.role == 80 || user.role == 60"
        @click="$router.push('/dashboard').catch(() => {})"
        class="text-font-14 mg-y-4"
      >
        <i class="fas fa-chart-line"></i>
        ข้อมูลสรุปของหลักสูตร
      </p>
    </div>
    <div
      v-if="user.role == 80 || user.role == 60"
      @click="$router.push('/manage/general').catch(() => {})"
      class="border-b pd-y-5 "
    >
      <p class="text-font-14 mg-y-4">
        <i class="fas fa-cog"></i>
        จัดการข้อมูลทั่วไป
      </p>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
}
</script>